/**
 * Mobile filter dropdown
 *
 * Anchors the filters drawer under the filter bar instead of letting it slide in from
 * the edge, so the Filter button reads as a dropdown. The panel is still the theme's
 * drawer — same form, same focus handling, same close behaviour — only its position
 * changes, which is why this measures rather than re-renders.
 *
 * The drawer opens as a modal dialog on narrow viewports, so it is positioned with
 * fixed coordinates read off the bar at open time. The theme locks scroll while it is
 * open, so the anchor cannot drift underneath it; only a resize can invalidate it.
 */
const GAP = 8;
const MIN_HEIGHT = 200;
const DROPDOWN_CLASS = 'filters-drawer--dropdown';

/** @param {Element} drawer - The filters drawer element. */
function position(drawer) {
  const button = document.querySelector('.facets-toggle__button');
  const bar = button?.closest('.facets-toggle') ?? button;
  if (!(bar instanceof HTMLElement) || !(drawer instanceof HTMLElement)) return;

  const rect = bar.getBoundingClientRect();
  const top = Math.round(rect.bottom + GAP);
  const available = Math.round(window.innerHeight - top - GAP);

  drawer.style.setProperty('--facets-dropdown-top', `${top}px`);
  drawer.style.setProperty('--facets-dropdown-left', `${Math.round(rect.left)}px`);
  drawer.style.setProperty('--facets-dropdown-width', `${Math.round(rect.width)}px`);
  drawer.style.setProperty('--facets-dropdown-max-height', `${Math.max(MIN_HEIGHT, available)}px`);
}

/** @returns {Element | null} The filters drawer, when it is set to open as a dropdown. */
function dropdownDrawer() {
  const drawer = document.getElementById('filters-drawer');
  return drawer?.classList.contains(DROPDOWN_CLASS) ? drawer : null;
}

// Capture phase, so the measurement lands before the button's own handler opens the
// drawer. Delegated from the document because the section is re-rendered on filtering,
// which replaces both the button and the drawer.
document.addEventListener(
  'click',
  (event) => {
    if (!(event.target instanceof Element)) return;
    if (!event.target.closest('.facets-toggle__button')) return;

    const drawer = dropdownDrawer();
    if (drawer) position(drawer);
  },
  true
);

window.addEventListener('resize', () => {
  const drawer = dropdownDrawer();
  if (drawer?.hasAttribute('open')) position(drawer);
});
